import {Component} from 'react';
import React from 'react';
import FormGroup from "react-bootstrap/lib/FormGroup";
import Col from "react-bootstrap/lib/Col";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import FormControl from "react-bootstrap/lib/FormControl";
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import Switch from "react-switch";
import Row from "react-bootstrap/es/Row";
import Button from "react-bootstrap/lib/Button";
import {InputGroup} from "react-bootstrap";

class ValidatedFormComponent extends Component {

    constructor(props) {
        /*
            Props:
             - onValidate (function(input))
             - inputRef (function(ref)) - ref contains .validated() function to determine if input is validated OK
             - onChange (function(value))

             - bsSize
             - validationState

             - value

             - defaultValue

             - disableFeedback

             - name
             - displayname
             - type (text,number,boolean,password,select,textarea,file,checkbox)
             - placeholder

             #IF type=='select'
                - value_key
                - display_name_key
                - options
                  - value
                  - display_name
             #ENDIF

             #IF type=='checkbox'
                - indeterminate
             #ENDIF

             #IF type=='number'
                - emptyAllowed
                - min
                - max
                - step
                - decimal
             #ENDIF

         */
        super(props);

        if(this.props.onValidate==null) {
            this.props.onValidate = function() {
                return null;
            }
        }

        const ref = {
            validated: this.validated.bind(this)
        }
        if(props.type==="checkbox") {
            Object.defineProperty(ref, 'checked', {get: () => this.props.value || this.state.value});
        } else {
            Object.defineProperty(ref, 'value', {get: () => this.props.value || this.state.value});
        }
        this.refObject = ref;

        if(this.props.type==='boolean') {
            this.state = {
                value: props.value==null ? 'false' : props.value,
                errMsg: null
            };
            if(props.defaultValue!=null) this.state.value = props.defaultValue;
            if(props.inputRef!=null) {
                props.inputRef(ref);
            }
            return;
        }

        this.state = {
            value: props.value==null ? '' : props.value,
            errMsg: null
        };
        if(props.defaultValue!=null) this.state.value = props.defaultValue;
    }

    validated() {
        if(this.props.type==='number') {
            const numValid = this.numberValidator(this.props.value || this.state.value);
            if(numValid!=null) {
                this.setState({
                    errMsg: numValid
                });
                return false;
            }
        }
        const errMsg = this.props.onValidate(this.props.value || this.state.value);
        this.setState({
            errMsg: errMsg
        })
        return errMsg==null;
    }

    numberValidator(value) {
        if(this.props.emptyAllowed && value==='') return null;
        if(value==='') return 'Value cannot be empty!';
        const val = this.props.decimal ? parseFloat(value) : parseInt(value);
        if(!this.props.decimal && !Number.isInteger(parseFloat(value))) return 'Must be an integer!';
        if(isNaN(val)) return 'Value is not a number!';
        if(this.props.min!=null && val<this.props.min) return 'Value cannot be lower than '+this.props.min+'!';
        if(this.props.max!=null && val>this.props.max) return 'Value cannot be higher than '+this.props.max+'!';
        return null;
    }

    componentDidMount() {
        if(this.inputRef!=null) {
            this.inputRef.indeterminate = this.props.indeterminate;
        }
    }

    componentDidUpdate() {
        if(this.inputRef!=null) {
            this.inputRef.indeterminate = this.props.indeterminate;
        }
        if(this.props.type==='boolean') {
            if(this.props.inputRef!=null) {
                this.props.inputRef(this.refObject);
            }
        }
    }

    render() {
        const errMsg = this.state.errMsg;
        const options = [];
        if(this.props.type==='select') {
            let i = 0;
            if(this.props.options!=null && this.props.value_key!=null && this.props.display_name_key!=null) for(let opt of this.props.options) {
                options.push(
                    (
                        <option key={'key'+i} value={opt[this.props.value_key]}>{opt[this.props.display_name_key]}</option>
                    )
                )
                i++;
            }
        }

        const inputCol = (
            <Col sm={this.props.name!=null ? 8 : 12} style={
                this.props.name==null ? {
                    paddingRight: '0px',
                    paddingLeft: '0px'
                } : {}
            }>
                <InputGroup>
                {
                    this.props.type==='checkbox' ?
                        (
                            <FormControl type="checkbox" bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} checked={this.props.value!=null ? this.props.value : this.state.value} onChange={(evnt) => {
                                const errMsg = this.props.onValidate(evnt.target.checked);
                                this.setState({
                                    value: evnt.target.checked,
                                    errMsg: errMsg
                                });
                                if(this.props.onChange!=null) this.props.onChange(evnt.target.checked);
                            }} style={{
                                height: "initial"
                            }} inputRef={_ref => {
                                this.inputRef = _ref;
                                this.refObject._ref = _ref;
                                if(_ref==null || this.props.inputRef==null) return;
                                this.props.inputRef(this.refObject);
                            }} />
                        ) :
                        this.props.type==='text' ?
                            (
                                <FormControl type="text" bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} value={this.props.value!=null ? this.props.value : this.state.value} onChange={(evnt) => {
                                    const errMsg = this.props.onValidate(evnt.target.value);
                                    this.setState({
                                        value: evnt.target.value,
                                        errMsg: errMsg
                                    });
                                    if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                }} placeholder={this.props.placeholder} inputRef={_ref => {
                                    this.inputRef = _ref;
                                    this.refObject._ref = _ref;
                                    if(_ref==null || this.props.inputRef==null) return;
                                    this.props.inputRef(this.refObject);
                                    // const ref = {_ref};
                                    // if(_ref==null || this.props.inputRef==null) return;
                                    // ref.validated = this.validated.bind(this);
                                    // Object.defineProperty(ref, 'value', {get: () => this.props.value || this.state.value});
                                    // this.props.inputRef(ref);
                                }} />
                            ) :
                            this.props.type==='file' ? (
                                <div>
                                    <FormControl type="file" bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} style={{
                                        display: "inline-block"
                                    }} value={this.props.value!=null ? this.props.value : this.state.value} onChange={(evnt) => {
                                        const errMsg = this.props.onValidate(evnt.target.value);
                                        this.setState({
                                            value: evnt.target.value,
                                            errMsg: errMsg
                                        });
                                        if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                    }} placeholder={this.props.placeholder} inputRef={ref => {
                                        if(ref==null || this.props.inputRef==null) return;
                                        ref.validated = this.validated.bind(this);
                                        this.inputRef = ref;
                                        this.props.inputRef(ref);
                                    }} />
                                    <Button bsStyle="danger" onClick={() => {
                                        this.inputRef.value = "";
                                        this.inputRef.files = null;

                                        const errMsg = this.props.onValidate("");
                                        this.setState({
                                            value: "",
                                            errMsg: errMsg
                                        });
                                        if(this.props.onChange!=null) this.props.onChange("");
                                    }}>
                                        Discard
                                    </Button>
                                    {this.props.currFN!=null ? (
                                        <div style={{
                                            marginLeft: "32px",
                                            display: "inline-block"
                                        }}>
                                            <b>Current file: </b>{this.props.currFN}
                                        </div>
                                    ) : ""}
                                </div>
                                ) :
                                this.props.type==='textarea' ? (
                                        <FormControl componentClass="textarea" bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} value={this.props.value!=null ? this.props.value : this.state.value} onChange={(evnt) => {
                                            const errMsg = this.props.onValidate(evnt.target.value);
                                            this.setState({
                                                value: evnt.target.value,
                                                errMsg: errMsg
                                            });
                                            if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                        }} placeholder={this.props.placeholder} inputRef={_ref => {
                                            this.inputRef = _ref;
                                            this.refObject._ref = _ref;
                                            if(_ref==null || this.props.inputRef==null) return;
                                            this.props.inputRef(this.refObject);
                                        }} />
                                    ) :
                                    this.props.type==='select' ?
                                        (
                                            <FormControl componentClass="select" bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} value={this.props.value!=null ? this.props.value : this.state.value} onChange={(evnt) => {
                                                const errMsg = this.props.onValidate(evnt.target.value);
                                                this.setState({
                                                    value: evnt.target.value,
                                                    errMsg: errMsg
                                                });
                                                if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                            }} placeholder={this.props.placeholder} inputRef={_ref => {
                                                this.inputRef = _ref;
                                                this.refObject._ref = _ref;
                                                if(_ref==null || this.props.inputRef==null) return;
                                                this.props.inputRef(this.refObject);
                                            }} >
                                                {options}
                                            </FormControl>
                                        ) :
                                        this.props.type==='password' ?
                                            (
                                                <FormControl type="password" bsSize={this.props.bsSize} bsStyle={this.props.bsStyle} value={this.props.value!=null ? this.props.value : this.state.value} onChange={(evnt) => {
                                                    const errMsg = this.props.onValidate(evnt.target.value);
                                                    this.setState({
                                                        value: evnt.target.value,
                                                        errMsg: errMsg
                                                    });
                                                    if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                                }} placeholder={this.props.placeholder} inputRef={_ref => {
                                                    this.inputRef = _ref;
                                                    this.refObject._ref = _ref;
                                                    if(_ref==null || this.props.inputRef==null) return;
                                                    this.props.inputRef(this.refObject);
                                                }} />
                                            ) :
                                            this.props.type==='number' ?
                                                (
                                                    <FormControl type="number"
                                                                 bsSize={this.props.bsSize}
                                                                 bsStyle={this.props.bsStyle}
                                                                 value={this.props.value!=null ? (isNaN(this.props.value) ? "" : this.props.value) : this.state.value}
                                                                 min={isNaN(this.props.min) ? "" : this.props.min}
                                                                 max={isNaN(this.props.max) ? "" : this.props.max}
                                                                 step={isNaN(this.props.step) ? "" : this.props.step}
                                                                 onChange={(evnt) => {
                                                                     const numValid = this.numberValidator(evnt.target.value);
                                                                     if(numValid!=null) {
                                                                         this.setState({
                                                                             value: evnt.target.value,
                                                                             errMsg: numValid
                                                                         });
                                                                         if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                                                         return;
                                                                     }
                                                                     const errMsg = this.props.onValidate(evnt.target.value);
                                                                     this.setState({
                                                                         value: evnt.target.value,
                                                                         errMsg: errMsg
                                                                     });
                                                                     if(this.props.onChange!=null) this.props.onChange(evnt.target.value);
                                                                 }} placeholder={this.props.placeholder} inputRef={_ref => {
                                                                    this.inputRef = _ref;
                                                                    this.refObject._ref = _ref;
                                                                    if(_ref==null || this.props.inputRef==null) return;
                                                                    this.props.inputRef(this.refObject);
                                                                }} />
                                                ) :
                                                this.props.type==='boolean' ?
                                                    (
                                                        <Switch
                                                            onChange={(checked) => {
                                                                const value = checked ? 'true' : 'false';
                                                                const errMsg = this.props.onValidate(value);
                                                                this.setState({
                                                                    value: value,
                                                                    errMsg: errMsg
                                                                })
                                                                if(this.props.onChange!=null) this.props.onChange(value);
                                                            }}
                                                            checked={(this.props.value!=null ? this.props.value : this.state.value)==='true'}
                                                            id={this.props.name}
                                                        />
                                                    ) : ''
                }

                {this.props.append!=null ? (
                    <InputGroup.Addon>{this.props.append}</InputGroup.Addon>
                ): ""}

                {this.props.disableFeedback ? '' : (<FormControl.Feedback />)}

                {errMsg!=null ? (<HelpBlock>{errMsg}</HelpBlock>) : ''}
                </InputGroup>
            </Col>
        );

        return (
            <FormGroup controlId={this.props.name} bsStyle={this.props.bsStyle} validationState={this.props.validationState==null ? errMsg==null ? null : 'error' : this.props.validationState}>
                {this.props.name!=null ? (
                    <Row>
                        <Col componentClass={ControlLabel} sm={4}>
                            {this.props.displayname!=null ? this.props.displayname : this.props.name}
                        </Col>
                        {inputCol}
                    </Row>
                    ) : inputCol}
            </FormGroup>
        );
    }
}

export default ValidatedFormComponent;